import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Circle from '@mui/icons-material/Circle';
import IconButton from '@mui/material/IconButton';
import Popper from '@mui/material/Popper';
import { Box } from '@mui/material';

import { ReactComponent as WarningTriangleRed } from '../assets/images/warning.svg';
import { ReactComponent as WarningTriangleOrange } from '../assets/images/warning-orange.svg';

const WarningTriangle = ({ message, errors, color = 'orange' }) => {
  const warningRef = useRef();
  const [popperOpen, setPopperOpen] = useState(false);

  const handleMouseEnter = () => {
    setPopperOpen(true);
  };

  const handleMouseLeave = () => {
    setPopperOpen(false);
  };

  const WarningTriangle = color === 'orange' ? WarningTriangleOrange : WarningTriangleRed;
  return (
    <>
      <IconButton ref={warningRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <WarningTriangle style={{ width: 20 }} />
      </IconButton>
      <Popper placement="right" open={popperOpen} anchorEl={warningRef.current} style={{ zIndex: 9999999 }}>
        <Box
          sx={{
            border: 1,
            borderColor: '#008296',
            borderRadius: 1,
            p: 1,
            bgcolor: 'white',
            color: '#262f5c',
            boxShadow: 12,
            fontWeight: 'bold',
            paddingTop: 2,
            paddingLeft: 2,
            paddingRight: 2,
          }}
        >
          {message && <Box sx={{ alignItems: 'center', display: 'flex' }}>{message}</Box>}
          {errors && errors.length > 0 && (
            <Box sx={{ paddingTop: 1.5, paddingBottom: 0.7 }}>
              {errors.map((e, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      color: '#002f7b',
                      fontWeight: 'normal',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'row',
                      paddingLeft: 0.8,
                    }}
                  >
                    <Circle sx={{ marginRight: 1, width: 7 }} />
                    <div style={{ paddingTop: 5 }}>{e.modalError ? e.modalError.msg : e.msg}</div>
                  </Box>
                );
              })}
            </Box>
          )}
          <Box sx={{ marginTop: 1 }}></Box>
        </Box>
      </Popper>
    </>
  );
};

WarningTriangle.propTypes = {
  message: PropTypes.string,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      msg: PropTypes.string,
      modalError: PropTypes.shape({
        msg: PropTypes.string,
      }),
    })
  ),
  color: PropTypes.oneOf(['orange', 'red']),
};

export default WarningTriangle;
